import debounce from 'lodash.debounce';

export default function benefitsSlider() {
  function getWidthOfElByVisibleSample(el) {
    let width = 0;
    const elements = document.body.querySelectorAll(`.${[...el.classList].join('.')}`);
    elements.forEach((sample) => {
      const sampleWidth = sample.offsetWidth;
      if (sampleWidth > width) {
        width = sampleWidth;
      }
    });
    return width;
  }

  function setElementsPostions(elementsList, percentValue) {
    const slider = elementsList[0].closest('.js-benefits-slider');
    const sliderWidth = getWidthOfElByVisibleSample(slider);

    elementsList.forEach((el) => {
      el.style.left = `${percentValue}%`;
      el.classList.remove('o-benefits-slider__edge-el');

      const marginPx = (sliderWidth / 100) * percentValue;
      const minMargin = parseInt(getWidthOfElByVisibleSample(el), 10) / 2;

      // check left edge
      if (marginPx < minMargin) {
        el.style.left = `${minMargin}px`;
      }

      // check right edge
      if ((sliderWidth - marginPx) < minMargin) {
        el.style.left = '100%';
        el.classList.add('o-benefits-slider__edge-el');
      }
    });
  }

  function createBenefitsSlider(wrap) {
    const input = wrap.querySelector('.js-benefits-slider-input');
    const currentValue = input.getAttribute('value');
    const maxValue = input.getAttribute('max');

    const percentValue = (currentValue / maxValue) * 100;

    const line = wrap.querySelector('.js-benefits-slider-line');
    line.style.width = `${percentValue}%`;

    const progressIndicator = wrap.querySelector('.js-benefits-slider-progress');
    const tooltip = wrap.querySelector('.js-benefits-slider-tooltip');
    setElementsPostions([progressIndicator, tooltip], percentValue);

    window.addEventListener(
      'resize',
      debounce(
        () => setElementsPostions([progressIndicator, tooltip], percentValue),
        500
      )
    );
  }

  const sliders = document.body.querySelectorAll('.js-benefits-slider');

  sliders.forEach((slider) => createBenefitsSlider(slider));
}
